import { CustomForm } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  templateId: number;
}

interface ResponseDataType {
  response: CustomForm[];
}

export const getFillTemplateCustomFormsRequest = ({ token, templateId }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form/fill-template?template_id=${ templateId }`, {
    token,
  });
};